import { StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export const getBracketTeamCellStyles = (theme: Theme) =>
  StyleSheet.create({
    teamCell: {
      flex: 1,
      alignItems: 'center',
      gap: 3,
    },
    crest: {
      width: 22,
      height: 22,
      alignItems: 'center',
      justifyContent: 'center',
    },
    code: {
      fontSize: 12,
      fontWeight: '700',
      color: theme.black,
      letterSpacing: 0.2,
    },
    dim: {
      color: theme.gray[400],
    },
    score: {
      fontSize: 12,
      fontWeight: '800',
      color: theme.black,
    },
    penalty: {
      fontSize: 10,
      fontWeight: '600',
      color: theme.gray[400],
    },
  })
